<script>
import Layout from '@layouts/main.vue'
import BaseButtonAngle from '@/src/components/_base-button-angle.vue'
import SubNav from '@/src/components/sub-nav.vue'
import PopOver from '@/src/components/pop-over.vue'

export default {
  page: {
    title: '02 00 Planning Overvie',
    meta: [
      { name: 'description', content: 'The 02 00 Planning Overvie page.' },
    ],
  },
  components: { Layout, BaseButtonAngle, SubNav, PopOver },
}
</script>

<template>
  <Layout>
    <BaseBgComponent img-u-r-l="2.0_planning.jpg" />
    <SubNav>
      <BaseButtonAngle clip-side="Right" click-active="inactive">
        <span>Path 04</span><br />
        Material Movement Overview
      </BaseButtonAngle>
    </SubNav>
    <BaseHotspot
      :pos-x="61"
      :pos-y="15"
      pos-unit="%"
      :rot-x="57"
      spot-active="inactive"
    />
    <BaseHotspot
      :pos-x="85"
      :pos-y="16"
      pos-unit="%"
      :rot-x="57"
      spot-active="inactive"
    />
    <router-link :to="{ name: 'material-movement' }">
      <BaseHotspot :pos-x="24" :pos-y="26" pos-unit="%" :rot-x="57" />
    </router-link>
    <router-link :to="{ name: 'material-movement' }">
      <BaseHotspot :pos-x="58" :pos-y="70" pos-unit="%" :rot-x="57" />
    </router-link>
    <PopOver
      title="Testing Title"
      pop-content="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer vulputate, quis varius ligula dui et velit. Sed hendrerit cursus odio, vitae tempor erat ultrices ut. Maecenas eu est a purus ornare congue a vitae arcu. Suspendisse nec nibh a arcu condimentum laoreet facilisis a orci. Maecenas quis porta purus. Ut ac pellentesque ligula, venenatis elementum libero. Morbi facilisis tristique risus, sed fringilla nisi commodo a. "
      :pos-x="38"
      :pos-y="35"
      pos-unit="%"
      pop-size="md"
      pop-height="300px"
    >
      <h1 class="m-t-5 m-b-15 p-b-15" style="border-bottom: solid 2px #fff;"
        >04 | Material Movement Overview</h1
      >
      <h3 class="m-t-5" style="font-weight: normal;">
        From strategic to operational plans, Hexagon improves your efficiency
        with a seamless flow of information.
      </h3>
    </PopOver>
    <router-link :to="{ name: 'material-movement' }">
      <BaseButton class="z-5" style="position: absolute; top: 60%; left: 45%;">
        ENTER
      </BaseButton>
    </router-link>
  </Layout>
</template>
